// export default ProductGrid;

import React from "react";
import {
  Grid,
  Box,
  Typography,
  IconButton,
  
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import KeyboardArrowUp from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import StarBorder from "@mui/icons-material/StarBorder";
import Star from "@mui/icons-material/Star";
import { useProductsOffers } from "../../../../../../../../context/OrderCreator/ProductContext";


const ProductGrid = ({ category, onSelectProduct, imageBaseUrl, placeholderImage }) => {
  const filtered = category.products || [];
  const { favorites = [], addToFavorites, removeFromFavorites } = useProductsOffers();

  const scrollRef = React.useRef();

  const scrollUp = () => {
    scrollRef.current.scrollBy({ top: -200, behavior: "smooth" });
  };

  const scrollDown = () => {
    scrollRef.current.scrollBy({ top: 200, behavior: "smooth" });
  };

  const getBranchId = () => {
    return (
      localStorage.getItem("branch_id") ||
      localStorage.getItem("branch id") ||
      localStorage.getItem("branchId") ||
      1
    );
  };
  
  const toggleFavorite = async (prod, isFav) => {
    const branchId = getBranchId();
    const payload = { product_id: prod.id, root_id: Number(branchId) || 1 };
    try {
      if (isFav) {
        await removeFromFavorites([payload]);
      } else {
        await addToFavorites([payload]);
      }
    } catch (e) {
      console.error("Favorite toggle error:", e);
    }
  };

  return (
    <Box position="relative">
      <IconButton
        onClick={scrollUp}
        sx={{ position: "absolute", top: 8, right: 8, zIndex: 10, bgcolor: "#fbc2eb", "&:hover": { bgcolor: "#ff9a9e" } }}
        size="small"
      >
        <KeyboardArrowUp />
      </IconButton>
      <IconButton
        onClick={scrollDown}
        sx={{ position: "absolute", bottom: 8, right: 8, zIndex: 10, bgcolor: "#fbc2eb", "&:hover": { bgcolor: "#ff9a9e" } }}
        size="small"
      >
        <KeyboardArrowDown />
      </IconButton>

      <Box
        ref={scrollRef}
        sx={{
          height: 500,
          overflowY: "auto",
          pr: 1,
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#3a3f4b",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#0d0d0d",
            borderRadius: "10px",
            border: "2px solid #3a3f4b",
            backgroundClip: "padding-box",
          },
          "&::-webkit-scrollbar-button": {
            display: "none",
          },
        }}
      >
        <Grid container spacing={2}>
          {filtered.map((prod) => (
            <Grid
              item
              xs={6}
              sm={4}
              md="auto"
              key={prod.id}
              sx={{
                flexBasis: { md: "16.666%", lg: "16.666%" },
                maxWidth: { md: "16.666%", lg: "16.666%" },
              }}
            >
              <Box
                className="product-hover-card"
                sx={{
                  position: "relative",
                  borderRadius: 4,
                  overflow: "hidden",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                  bgcolor: "#1a1a2e",
                  border: "1px solid rgba(255,255,255,0.05)",
                  minHeight: 150,
                  cursor: "pointer",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  "&:hover": {
                    boxShadow: "0 12px 40px rgba(251, 194, 235, 0.25)",
                    transform: "translateY(-8px) scale(1.02)",
                    border: "1px solid rgba(251, 194, 235, 0.3)",
                  },
                }}
                onClick={() => onSelectProduct(prod)}
                title={prod.description || ""}
              >
                {/* زر النجمة لإضافة/إزالة من المفضلة */}
                {(() => {
                  const isFav = favorites.some((f) => String(f.id) === String(prod.id));
                  return (
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleFavorite(prod, isFav);
                      }}
                      size="small"
                      sx={{
                        position: "absolute",
                        top: 10,
                        left: 10,
                        zIndex: 40,
                        width: 36,
                        height: 36,
                        bgcolor: isFav ? "rgba(255, 213, 79, 0.95)" : "rgba(0, 0, 0, 0.4)",
                        backdropFilter: "blur(8px)",
                        color: isFav ? "#000" : "#fff",
                        boxShadow: isFav ? "0 4px 12px rgba(255, 193, 7, 0.4)" : "0 2px 8px rgba(0,0,0,0.3)",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          bgcolor: isFav ? "#ffc107" : "rgba(255,255,255,0.15)",
                          transform: "scale(1.15) rotate(10deg)",
                          boxShadow: "0 6px 20px rgba(251, 194, 235, 0.5)",
                        },
                      }}
                    >
                      {isFav ? <Star fontSize="small" /> : <StarBorder fontSize="small" />}
                    </IconButton>
                  );
                })()}
                <Box
                  component="img"
                  src={prod.image ? `${imageBaseUrl}${prod.image}` : placeholderImage}
                  alt={prod.name}
                  sx={{
                    width: "100%",
                    height: 110,
                    objectFit: "cover",
                    display: "block",
                    filter: "brightness(0.75) contrast(1.1)",
                    transition: "all 0.3s ease",
                    ".product-hover-card:hover &": {
                      filter: "brightness(0.85) contrast(1.15)",
                      transform: "scale(1.05)",
                    },
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    onSelectProduct(prod);
                  }}
                />
                <Box
                  sx={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    bottom: 0,
                    p: 0,
                    color: "#fff",
                    background: "linear-gradient(0deg, rgba(26,26,46,0.95) 70%, rgba(26,26,46,0.7) 85%, rgba(26,26,46,0) 100%)",
                    backdropFilter: "blur(4px)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "flex-end",
                    minHeight: 60,
                    height: "55px",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "1rem",
                      mb: 0,
                      px: 1.5,
                      pt: 1,
                      color: "#fff",
                      textShadow: "0 2px 8px rgba(0,0,0,0.6)",
                      letterSpacing: "0.3px",
                    }}
                  >
                    {prod.name || "بدون اسم"}
                  </Typography>
                  <Box sx={{ display: "flex", width: "100%", alignItems: "center", px: 1.5, pb: 0.8 }}>
                    <Typography
                      sx={{
                        color: "#fbc2eb",
                        fontSize: "1rem",
                        fontWeight: 700,
                        flex: 1,
                        textShadow: "0 1px 4px rgba(0,0,0,0.4)",
                      }}
                    >
                      {prod.price}
                    </Typography>
                    <IconButton
                      sx={{
                        background: "linear-gradient(135deg, #fbc2eb 0%, #ff9a9e 100%)",
                        color: "#232334",
                        width: 30,
                        height: 30,
                        boxShadow: "0 4px 12px rgba(251, 194, 235, 0.4)",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          background: "linear-gradient(135deg, #ff9a9e 0%, #fbc2eb 100%)",
                          transform: "scale(1.1) rotate(5deg)",
                          boxShadow: "0 6px 20px rgba(251, 194, 235, 0.6)",
                        },
                        ml: 1,
                        p: 0,
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        onSelectProduct(prod);
                      }}
                    >
                      <AddIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Box>
                {/* وصف الصنف يظهر عند الوقوف عليه */}
                {prod.description && (
                  <Box
                    className="product-description-hover"
                    sx={{
                      display: "block",
                      position: "absolute",
                      left: 0,
                      right: 0,
                      bottom: 55,
                      background: "linear-gradient(135deg, rgba(26,26,46,0.98) 0%, rgba(35,35,52,0.98) 100%)",
                      backdropFilter: "blur(10px)",
                      border: "1px solid rgba(251, 194, 235, 0.3)",
                      color: "#fff",
                      px: 2,
                      py: 1.5,
                      borderRadius: 3,
                      fontSize: 13.5,
                      fontWeight: 500,
                      lineHeight: 1.5,
                      zIndex: 50,
                      boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
                      opacity: 0,
                      pointerEvents: "none",
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      textAlign: "center",
                      maxWidth: "95%",
                      mx: "auto",
                      whiteSpace: "pre-line",
                    }}
                  >
                    {prod.description}
                  </Box>
                )}
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
      {/* CSS احترافي للهوفر */}
      <style>
        {`
          .product-hover-card {
            position: relative;
          }
          .product-hover-card:hover .product-description-hover {
            opacity: 1 !important;
            pointer-events: auto !important;
            transform: translateY(-12px) scale(1.02);
            background: linear-gradient(135deg, rgba(26,26,46,0.98) 0%, rgba(251, 194, 235, 0.15) 100%);
            backdrop-filter: blur(12px);
             color: #fff;
            box-shadow: 0 12px 48px rgba(251, 194, 235, 0.3);
            border-color: rgba(251, 194, 235, 0.5);
           }
         `}
      </style>
    </Box>
  );
};

export default ProductGrid;
